<template>
<div class="col-sm-3 col-lg-3 col-xl-3 text-center" id="businessname">
<div class="row" >
  <div class="col-sm-12" id="sponsors" style="margin-left: -12px; padding-bottom: 10px;">
    <h2> SPONSORS </h2>
  </div>
  <div v-for="sponsor in totalSponsors" :key="sponsor" class="col-sm-12 col-lg-12 col-xl-12 text-center" :id="'businessname'+sponsor">
    <div class="business-text">
      <div class="centered-text text-center"><p>BUISNESS NAME</p></div>
      <div class="centered-para text-center"><p><em>Lorem ipsum dolor sit amet, consectetur
        adipiscing
        elit</em></p></div>
    </div>
  </div>
</div>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'sponsors-page',
  props: {
    totalSponsors: {
      default: 3
    }
  }
});
</script>
